export default __webpack_public_path__ + "static/media/overlay.10a6e6a6.svg";